import React from "react";

const LoadingSpinner = () => {
  return (
    <div className="loading-container">
      <div className="loader"></div>
      <p>Loading delicious food...</p>
    </div>
  );
};

export default LoadingSpinner;
